import  { useEffect, useState } from "react";
import LoanSummary from "./components/LoanSummary/LoanSummary";
import PaymentDetails from "./components/PaymentDetails/PaymentDetails";
import { useLocation, useNavigate } from "react-router-dom";
import EMIsAPI from "../../services/emi-api";

export default function Repayment() {
  const [amount, setAmount] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRepaymentData = async () => {
      const { getRepaymentAmountAPI } = new EMIsAPI();
      const res = await getRepaymentAmountAPI();

      if (res && res.status === "1") {
        setAmount(res.data.Total_Payable_Amount);
      }
    };

    fetchRepaymentData();
  }, []);

  // const { amount } = location.state || {};

  // useEffect(() => {
  //   if (!amount) {
  //     navigate("/dashboard");
  //   }
  // }, [amount, navigate]);

  return (
    <div className="wrapper auto-height bg-white">
      <LoanSummary amount={amount} />
      <PaymentDetails amount={amount} />
    </div>
  );
}
